import * as React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

interface ILinkProps {
  key?: string | number;
  to: string | any;
  children: JSX.Element | string;
  target?: string;
  className?: string;
}

const isUrl = (link: string) => typeof link === 'string' && link.indexOf('http') > -1;

const Link = (props: ILinkProps) => {
  if (isUrl(props.to)) {
    return <a
      key={props.key}
      href={props.to}
      target={props.target}
      className={props.className}
    >
      {props.children}
    </a>;
  }

  return <ReactRouterLink
      key={props.key}
      to={props.to}
      target={props.target}
      className={props.className}
    >
      {props.children}
    </ReactRouterLink>;
};

export default Link;


// WEBPACK FOOTER //
// ./src/components/Link.tsx